<script setup lang="ts">

interface Props {
    title: string;
    balance: number | string;
    loading?: boolean;
}

defineProps<Props>();
</script>

<template>
    <div class="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow p-4 text-white">
        <div class="text-sm mb-2">{{ title }}</div>

        <!-- Skeleton Loading State -->
        <div v-if="loading" class="text-2xl font-bold mb-4">
            <div class="h-8 w-24 bg-blue-400/30 rounded animate-pulse"></div>
        </div>

        <!-- Actual Balance -->
        <div v-else class="text-2xl font-bold mb-4">{{ balance }}</div>
    </div>
</template>
